export enum LAYOUT_TYPES {
  CLASSIC = 'CLASSIC',
  DUAL = 'DUAL',
}
